// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__uJjAz","expandIcon":"AccordionButton_expandIcon__1VQZn","expanded":"AccordionButton_expanded__Nmhxh"};